import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import type { Language } from '../../content/site';
const OPTIONS: {
  value: Language;
  label: string;
}[] = [{
  value: 'en',
  label: 'EN'
}, {
  value: 'es',
  label: 'ES'
}];
export function LanguageToggle({
  tone = 'dark'
}: {
  tone?: 'dark' | 'light';
}) {
  const {
    language,
    setLanguage
  } = useLanguage();
  const border = tone === 'dark' ? 'border-espresso/15' : 'border-pearl/25';
  return <div role="group" aria-label="Language selector" className={`inline-flex items-center rounded-full border p-0.5 ${border}`} data-id="element-146" data-mp="2od7yuxc99gcl">
      {OPTIONS.map(opt => {
      const active = language === opt.value;
      const activeCls = tone === 'dark' ? 'bg-espresso text-cream' : 'bg-pearl text-espresso';
      const idleCls = tone === 'dark' ? 'text-espresso/50 hover:text-espresso' : 'text-pearl/55 hover:text-pearl';
      return <button key={opt.value} type="button" onClick={() => setLanguage(opt.value)} aria-pressed={active} className={`rounded-full px-3 py-1.5 text-[10px] font-semibold tracking-[0.14em] transition-colors ${active ? activeCls : idleCls}`} data-id="element-147" data-mp="17yotv68uywsq">
            {opt.label}
          </button>;
    })}
    </div>;
}